import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import type { QuotaType } from '@/config/plans'
import type { ReactNode } from 'react'

export interface QuotaWarningTooltipProps {
	quotaKey: QuotaType
	used: number
	total: number
	label?: string
	children: ReactNode
}

export function QuotaWarningTooltip({ quotaKey, used, total, label, children }: QuotaWarningTooltipProps) {
	const percentage = total > 0 ? (used / total) * 100 : 0
	const defaultLabel = `${used} of ${total} ${quotaKey.toLowerCase()} used (${Math.round(percentage)}%)`
	return (
		<Tooltip>
			<TooltipTrigger asChild>{children}</TooltipTrigger>
			<TooltipContent>{label ?? defaultLabel}</TooltipContent>
		</Tooltip>
	)
}
